import { useState, useContext, useEffect } from 'react';
import { LanguageContext } from '../../shared/contexts/Language.context';

export default function useLanguageSelector() {
  const { state: languageContextState, actions: languageContextActions } = useContext(
    LanguageContext
  );
  const [state, setState] = useState({ loading: true, languages: [] });

  const actions = {
    loadLanguages: languages => updateState({ languages }),
    handleChange: language => {
      languageContextActions.setLanguage(language);
    },
  };

  useEffect(() => {
    actions.loadLanguages(languageContextState.languages);
  }, [languageContextState.languages]);

  useEffect(() => {
    updateState({ selectedLanguage: languageContextState.selectedLanguage });
  }, [languageContextState.selectedLanguage]);

  function updateState(newState) {
    setState(previousState => ({ ...previousState, ...newState }));
  }

  return { state, actions };
}
